const TipoRepeticion = {
  noRepetir: "TR_NoRepetir",
  minutoDelDia: "TR_MinutoDelDia",
  horaDelDia: "TR_HoraDelDia",
  diaDelMes: "TR_DiaDelMes",
  diaDelAnio: "TR_DiaDelAnio",
  semanaDelAnio: "TR_SemanaDelAnio",
  decenaDelAnio: "TR_DecenaDelAnio",
  mesDelAnio: "TR_MesDelAnio",
  anioDeLaDecada: "TR_AnioDeLaDecada",
  decadaDelSiglo: "TR_DecadaDelSiglo"
};

const ArrayTipoRepeticion = [
  TipoRepeticion.noRepetir,
  TipoRepeticion.minutoDelDia,
  TipoRepeticion.horaDelDia,
  TipoRepeticion.diaDelMes,
  TipoRepeticion.diaDelAnio,
  TipoRepeticion.semanaDelAnio,
  TipoRepeticion.decenaDelAnio,
  TipoRepeticion.mesDelAnio,
  TipoRepeticion.anioDeLaDecada,
  TipoRepeticion.decadaDelSiglo
];

const intToTipoRepeticion = intValue => {
  if ((intValue >= 0) && (intValue < ArrayTipoRepeticion.length))
    return ArrayTipoRepeticion[intValue];
  return undefined;
};

const tipoRepeticionToInt = (tipoRepeticion) => {
    return ArrayTipoRepeticion.indexOf(tipoRepeticion);
};

const TipoRegistroSustitutoAUsar = {
  ninguno: "TRSAU_Ninguno",
  soloSeriesDeLaMismaEstacion: "TRSAU_SoloSeriesDeLaMismaEstacion",
  soloSeriesDeOtrasEstaciones: "TRSAU_SoloSeriesDeOtrasEstaciones",
  seriesDeLaMismaUOtrasEstaciones: "TRSAU_SeriesDeLaMismaUOtrasEstaciones"
};

// Acciones a aplicar cuando se encuentra un dato nulo
// NA_ninguna: no chequea la presencia de nulos
// NA_quitar: quita los elementos nulos de los datos
// NA_promedioPeriodo: sustituye los elementos nulos de los datos con su promedio por período
// NA_medianaPeriodo: sustituye los elementos nulos de los datos con su mediana por período
// NA_InterpolLineal: sustituye los elementos nulos de los datos con una interpolación lineal entre el elemento anterior y el siguiente
// NA_promedioLargoPlazo: sustituye los elementos nulos de los datos con el promedio de toda la serie
// NA_medianaLargoPlazo: sustituye los elementos nulos de los datos con la mediana de toda la serie
// NA_error: lanza una excepción
const NA_Action = {
  ninguna: "NA_ninguna",
  quitar: "NA_quitar",
  promedioPeriodo: "NA_promedioPeriodo",
  medianaPeriodo: "NA_medianaPeriodo",
  interpolLineal: "NA_InterpolLineal",
  interpolLineal_HuecoMax1: "NA_InterpolLineal_HuecoMax1",
  interpolLineal_HuecoMax2: "NA_InterpolLineal_HuecoMax2",
  interpolLineal_HuecoMax5: "NA_InterpolLineal_HuecoMax5",
  interpolLineal_HuecoMax11: "NA_InterpolLineal_HuecoMax11",
  promedioLargoPlazo: "NA_promedioLargoPlazo",
  medianaLargoPlazo: "NA_medianaLargoPlazo",
  error: "NA_error"
};

const FuncionAgregacion = {
  acumulado: "Acumulado",
  promedio: "Promedio",
  promedioMinMaxSobre2: "Promedio (Min + Max) / 2",
  promedioRecortado: "Promedio Recortado (2.5%)",
  mediana: "Mediana",
  cantDatosDisp: "Cantidad de datos disponibles",
  porcentDatosDisp: "Porcentaje de datos disponibles",
  cantDatosNoDisp: "Cantidad de datos no disponibles",
  porcentDatosNoDisp: "Porcentaje de datos no disponibles",
  minimo: "Mínimo",
  maximo: "Máximo",
  fechaDelMinimo: "Fecha del Mínimo",
  fechaDelMaximo: "Fecha del Máximo",
  desviacionEstandar: "Desviación Estándar",
  varianza: "Varianza",
  rangoIntercuartil: "Rango Intercuartil",
  cotaInfReglaRangoInterCuartil:
    "Cota Inferior de la  Regla del Rango InterCuartil",
  cotaSupReglaRangoInterCuartil:
    "Cota Superior de la  Regla del Rango InterCuartil",
  rumboMasFrecuente: "Rumbo más Frecuente",
  rumboMasFrecuenteCada10Grados: "Rumbo más Frecuente Cada 10º",
  cuantil: "Cuantil",
  primerValor: "Primer Valor",
  ultimoValor: "Último Valor",
  primerValorNoNulo: "Primer Valor No Nulo",
  ultimoValorNoNulo: "Último Valor No Nulo"
};

const ArrayFuncionAgregacion = [
  FuncionAgregacion.acumulado,
  FuncionAgregacion.promedio,
  FuncionAgregacion.promedioMinMaxSobre2,
  FuncionAgregacion.promedioRecortado,
  FuncionAgregacion.mediana,
  FuncionAgregacion.cantDatosDisp,
  FuncionAgregacion.porcentDatosDisp,
  FuncionAgregacion.cantDatosNoDisp,
  FuncionAgregacion.porcentDatosNoDisp,
  FuncionAgregacion.minimo,
  FuncionAgregacion.maximo,
  FuncionAgregacion.fechaDelMinimo,
  FuncionAgregacion.fechaDelMaximo,
  FuncionAgregacion.desviacionEstandar,
  FuncionAgregacion.varianza,
  FuncionAgregacion.rangoIntercuartil,
  FuncionAgregacion.cotaInfReglaRangoInterCuartil,
  FuncionAgregacion.cotaSupReglaRangoInterCuartil,
  FuncionAgregacion.rumboMasFrecuente,
  FuncionAgregacion.rumboMasFrecuenteCada10Grados,
  FuncionAgregacion.cuantil,
  FuncionAgregacion.primerValor,
  FuncionAgregacion.ultimoValor,
  FuncionAgregacion.primerValorNoNulo,
  FuncionAgregacion.ultimoValorNoNulo
];

const intToFuncionAgregacion = (intValue)=>{
  if ((intValue >= 0) && (intValue < ArrayFuncionAgregacion.length))
    return ArrayFuncionAgregacion[intValue];
  return undefined;
}

const funcionAgregacionToInt = (funcionAgregacion)=>{
  return ArrayFuncionAgregacion.indexOf(funcionAgregacion);
}

export {
  NA_Action,
  TipoRegistroSustitutoAUsar,
  TipoRepeticion,
  FuncionAgregacion,
  intToTipoRepeticion,
  intToFuncionAgregacion,
  tipoRepeticionToInt,
  funcionAgregacionToInt
};
